<template>
    <div class="outs" v-if="showOuts">
        <div class="outs-title">赛况</div>
        <div class="item flex-center" v-if="weekTag || timeRangeText">
          <div class="label flex-center">
            <img src="https://images.snsports.cn/FrqJIM-9gAGM9Kn0sXvuilAvdwiW" />
            <div>时间</div>
          </div>
          <div class="value flex-center-value">
            <span v-if="weekTag" class="date">{{ weekTag }}</span>
            <span>{{ timeRangeText }}</span>
          </div>
        </div>
        <div class="item flex-center" v-if="info.location">
          <div class="label flex-center">
            <img src="https://images.snsports.cn/Fn67MLlgZQm7rynts2ihT4oX7E6t" />
            <div>地点</div>
          </div>
          <div class="value">{{ info.location }}</div>
        </div>
        <div class="item flex-center" v-if="mainRefereeText">
          <div class="label flex-center">
            <img src="https://images.snsports.cn/FmO5mV8027PknB_Cc7UJXF7Zxh-n" />
            <div>主裁判</div>
          </div>
          <div class="value">{{ mainRefereeText }}</div>
        </div>
        <div class="item flex-center" v-if="assistantRefereeText">
          <div class="label flex-center">
            <img src="https://images.snsports.cn/FmO5mV8027PknB_Cc7UJXF7Zxh-n" />
            <div>助理裁判</div>
          </div>
          <div class="value">{{ assistantRefereeText }}</div>
        </div>
    </div>
</template>

<script>
import Moment from 'moment'
import {
  mainRefereeTextFromInfo,
  assistantRefereeTextFromInfo,
  hasMatchOutsData,
} from '../matchOutsHelpers'

export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    weekTag() {
      const raw = this.info.beginDate
      if (!raw) return ''
      const m = Moment(raw)
      if (!m.isValid()) return ''
      const days = ['日', '一', '二', '三', '四', '五', '六']
      return `周${days[m.day()]}`
    },
    timeRangeText() {
      const raw = this.info.beginDate
      if (!raw) return '—'
      const b = Moment(raw)
      if (!b.isValid()) return '—'
      const endRaw = this.info.endDate
      if (endRaw) {
        const e = Moment(endRaw)
        if (e.isValid() && b.format('YYYY-MM-DD') === e.format('YYYY-MM-DD')) {
          return `${b.format('YYYY-MM-DD')} ${b.format('HH:mm')}~${e.format('HH:mm')}`
        }
        if (e.isValid()) {
          return `${b.format('YYYY-MM-DD HH:mm')}~${e.format('DD HH:mm')}`
        }
      }
      return b.format('YYYY-MM-DD HH:mm')
    },
    mainRefereeText() {
      return mainRefereeTextFromInfo(this.info)
    },
    assistantRefereeText() {
      return assistantRefereeTextFromInfo(this.info)
    },
    showOuts() {
      return hasMatchOutsData(this.info)
    },
  },
}
</script>

<style scoped lang="scss">
.outs {
  background: #fff;
  padding: 12px;
  margin-top: 12px;
    .outs-title {
      padding-left: 4px;
      font-size: 15px;
      font-weight: bold;
      color: #3D3D3D;
    }
    .item {
      margin-top: 10px;
      font-size: 13px;
      color: #4F4F4F;
      .label {
        flex-shrink: 0;
        margin-right: 20px;
        > * + * {
          margin-left: 8px;
        }
      }
      .value {
        flex: 1;
        .date {
          display: inline-block;
          width: 38px;
          height: 16px;
          border-radius: 3px;
          background: #C82121;
          color: #FFFFFF;
          font-size: 12px;
          text-align: center;
          line-height: 16px;
          margin-right: 8px;
        }
      }
      img{
        width: 16px;
        height: 16px;
      }
    }
}
</style>
